"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagToJSON = exports.FeatureFlagFromJSONTyped = exports.FeatureFlagFromJSON = exports.instanceOfFeatureFlag = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FeatureFlag interface.
 */
function instanceOfFeatureFlag(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFeatureFlag = instanceOfFeatureFlag;
function FeatureFlagFromJSON(json) {
    return FeatureFlagFromJSONTyped(json, false);
}
exports.FeatureFlagFromJSON = FeatureFlagFromJSON;
function FeatureFlagFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
    };
}
exports.FeatureFlagFromJSONTyped = FeatureFlagFromJSONTyped;
function FeatureFlagToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': value.value,
    };
}
exports.FeatureFlagToJSON = FeatureFlagToJSON;
